/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DealerAddress
 */
export interface DealerAddress {
  /**
   *
   * @type {string}
   * @memberof DealerAddress
   */
  streetName?: string | null
  /**
   *
   * @type {string}
   * @memberof DealerAddress
   */
  streetNumber?: string | null
  /**
   *
   * @type {string}
   * @memberof DealerAddress
   */
  streetLetter?: string | null
  /**
   *
   * @type {string}
   * @memberof DealerAddress
   */
  postalCode?: string | null
  /**
   *
   * @type {string}
   * @memberof DealerAddress
   */
  city?: string | null
}

/**
 * Check if a given object implements the DealerAddress interface.
 */
export function instanceOfDealerAddress(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function DealerAddressFromJSON(json: any): DealerAddress {
  return DealerAddressFromJSONTyped(json, false)
}

export function DealerAddressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DealerAddress {
  if (json === undefined || json === null) {
    return json
  }
  return {
    streetName: !exists(json, 'StreetName') ? undefined : json['StreetName'],
    streetNumber: !exists(json, 'StreetNumber')
      ? undefined
      : json['StreetNumber'],
    streetLetter: !exists(json, 'StreetLetter')
      ? undefined
      : json['StreetLetter'],
    postalCode: !exists(json, 'PostalCode') ? undefined : json['PostalCode'],
    city: !exists(json, 'City') ? undefined : json['City'],
  }
}

export function DealerAddressToJSON(value?: DealerAddress | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    StreetName: value.streetName,
    StreetNumber: value.streetNumber,
    StreetLetter: value.streetLetter,
    PostalCode: value.postalCode,
    City: value.city,
  }
}
